<template>
  <div class="welcome">
    <h1>Charg<i class="fas fa-plug"></i>d</h1>
    <p id="mission-statement">Keep track of how much time has passed since you last charged your electronic devices, maintained your bike, or any other important task</p>
  </div>
</template>

<script>

export default {
  name: 'Welcome',
}
</script>

<style scoped>
.welcome {
  text-align: center;
}

#mission-statement {
  max-width: 90%;
  margin: 50px auto;
  font-size: 125%;
  font-weight: bold;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
}

/* body {
    background-image: url('~@/assets/wallpaper.jpg');
  min-height: 100%;
  background-size:inherit;
  background-repeat: no-repeat;
} */
</style>